import React, { useState , useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Modal, ModalBody, ModalHeader, Row, Col, ListGroupItem, ListGroup, Input, Label} from 'reactstrap';
import { Create_New_Group, get_payment_summary, Get_Plans } from '../../../slices/thunks';
import { useSelector } from 'react-redux';
import Loader from '../Loader';
import config from '../../../config';

const Create_New_Group_modal = () => {
    const {  No_Group_Created  }  = useSelector((state)=>state.Group_List)
    const [current_plan_details, setcurrent_plan_details] = useState({})
    const [modal_standard, setmodal_standard] = useState(false);
    const { loading } = useSelector((state)=>state.Group_List)
    const [input, setinput] = useState('')
    const [Max_Token_Allowed, setMax_Token_Allowed] = useState(config.general_config.Max_Token_Allowed)
    const {PlanName,Plan_Id} = useSelector((state)=>state.Plans.current_plan_details)
    const {plans} = useSelector((state)=>state.Plans)
    const dispatch = useDispatch()
    function tog_standard_CNG() {
        setmodal_standard(!modal_standard);
    }


    useEffect(() => {

        setinput('')
     
    }, [modal_standard, setmodal_standard])


    
    useEffect(() => {
          
        setmodal_standard(No_Group_Created)
        dispatch(get_payment_summary())
        dispatch(Get_Plans())
        


    },[])
    useEffect(() => {
        const plan_temp = plans?.filter(plan => plan.plan_id === Plan_Id)       
        if(plan_temp){

            setcurrent_plan_details(plan_temp[0])
        }
    }, [plans])
    


    const onClick_create_new_group = () =>{

        if(input.trim().length === 0){
            return
        }
        
        dispatch(Create_New_Group({ Group_Name:input , Token_Allowed:Max_Token_Allowed }))

    }
    



  return (
    <>
      <Button onClick={() => tog_standard_CNG()}>CREATE NEW GROUP</Button>
      
      {/* Default Modal */}
        <Modal id="myModal"
            isOpen={modal_standard}
            toggle={() => {
                tog_standard_CNG();
            }}
        >
            <ModalHeader className="modal-title"
                id="myModalLabel" toggle={() => {
                    tog_standard_CNG();
                }}> 
                CREATE NEW GROUP
            </ModalHeader>
           
          { loading? <Loader/>:  <><ModalBody>
                <div className='add_new_user_inner'>
                {No_Group_Created && <p className='modal-title' >You need to create a group first before creating a bot</p>}
                    <Row>
                        <Col md={12}>
                            <div className='user_name'>
                                <Label>Group Name</Label>
                              <Input onChange={(e)=>{
                                setinput(e.target.value)

                                }} value={input} type='text'/>
                                </div>
                            </Col>
                            <Col md={12}>
                            <div className='user_name mt-30'>
                                <Label>Max Token Allowed / Month </Label>
                                <Input 
                                value={Max_Token_Allowed.toLocaleString()} 
                                onChange={(e) => {
                                    // Remove formatting (commas) to handle raw numeric input
                                    const rawValue = e.target.value.replace(/,/g, '');
                                    
                                    // Check if the input is a valid number
                                    if (!isNaN(rawValue)) {
                                    setMax_Token_Allowed(parseInt(rawValue, 10) || 0);
                                    }
                                }} 
                                type="text"
                                />

                                </div>
                            </Col>
                            <Col md={6} style={{marginTop:'25px'}}>
                                <Label>Plan Name </Label>
                                <h5>{PlanName}</h5>
                            </Col>
                            <Col md={6} style={{marginTop:'25px'}}>
                                <Label>Free Tokens</Label>
                                <h5>{current_plan_details?.FreeTokens?.toLocaleString()}</h5>
                            </Col>
                            
                        </Row>    
                        
                    </div>
                </ModalBody>
                <div className="modal-footer">            
                    {/* <Button
                        color="light"
                        onClick={() => {
                            tog_standard_CNG();
                        }}
                    >
                        Close
                    </Button> */}
                    <Button
                    onClick={onClick_create_new_group}
                        color="secondary"
                    >
                        Create Group
                    </Button>
                </div>
            </>}
            
        </Modal>
    </>
  )
}

export default Create_New_Group_modal
